import React, { useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from '../auth/authConfig';
import './Login.css';

const Login = () => {
  const { instance, inProgress } = useMsal();
  const [error, setError] = useState(null);

  const isInIframe = window.self !== window.top;

  const handleLogin = async () => {
    if (inProgress !== "none") {
      console.log('Login already in progress...');
      return;
    }

    try {
      setError(null);
      console.log(`Initiating Microsoft login (${isInIframe ? 'popup' : 'redirect'})...`);
      if (isInIframe) {
        await instance.loginPopup(loginRequest);
      } else {
        await instance.loginRedirect(loginRequest);
      }
    } catch (e) {
      console.error('Login error:', e);
      if (e.errorCode === 'interaction_in_progress') {
        setError('Login is already in progress. Please wait...');
      } else if (e.errorCode === 'popup_window_error') {
        setError('Popup was blocked. Please allow popups for this site.');
      } else {
        setError('Failed to initiate login. Please try again.');
      }
    }
  };

  return (
    <div className="login-page">
      <div className="login-background"></div>
      <div className="login-container">
        <div className="login-card">
          <div className="login-logo-section">
            <div className="rb-logo">
              <svg width="60" height="60" viewBox="0 0 60 60">
                <circle cx="30" cy="30" r="28" fill="#DC143C"/>
                <circle cx="30" cy="30" r="20" fill="none" stroke="white" strokeWidth="3"/>
              </svg>
            </div>
            <h1 className="login-title">Agent Status Dashboard</h1>
            <p className="login-subtitle">Redbull Liberty Support</p>
          </div>

          <div className="login-content">
            <p className="login-description">
              Monitor and manage contact center agents in real-time
            </p>

            {error && (
              <div className="login-error">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                </svg>
                {error}
              </div>
            )}

            <button 
              className="login-btn" 
              onClick={handleLogin}
              disabled={inProgress === "login"}
            >
              {inProgress === "login" ? (
                <>
                  <div className="login-spinner"></div>
                  Signing in...
                </>
              ) : (
                <>
                  <svg width="21" height="21" viewBox="0 0 21 21" className="ms-logo">
                    <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                    <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                    <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                    <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
                  </svg>
                  Sign in with Microsoft
                </>
              )}
            </button>

            <div className="login-footer">
              <p className="login-info">
                Use your Red Bull Microsoft account to access the dashboard
              </p>
            </div>
          </div>
        </div>

        <div className="login-features">
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            <span>Real-time Agent Monitoring</span>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
            </svg>
            <span>Historical Activity Tracking</span>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/>
            </svg>
            <span>Productivity Analytics</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

